import Vue from 'vue'
import App from './App'
import router from './router'
import './http'
import '../static/ionic.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import swal from 'sweetalert'

Vue.prototype.$swal = swal

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC5uRQvpYkzVNBcW19JsyXy2EYbmShS5pA'
  }
})

function detectPlatform() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    document.documentElement.classList.add('platform-ios')
    return 'ios'
  } else if (/android/i.test(userAgent)) {

    document.documentElement.classList.add('platform-android')
    return 'android'
  } else {
    document.documentElement.classList.add('platform-android')
    return 'web'
  }
}

const platform = detectPlatform()

Vue.prototype.$platform = platform

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    $env () {
      return {
        companyName: process.env.COMPANY_NAME,
        companyLogo: process.env.COMPANY_LOGO,
        mobileNumber: process.env.MOBILE_NUMBER,
        appTitle: process.env.COMPANY_NAME + ' - Móvil ' + process.env.MOBILE_NUMBER
      }
    }
  }
})

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('static/service-worker.js');
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js